import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_EDIT_STATUS, SET_LOCK_STATUS } from "../../../redux/actions/types";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const NavbarOwner = () => {
    const dispatch = useDispatch();
    const variant = useSelector((store)=> store?.certificateVerification?.userType);
    const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);
  return (
    <div className="flex w-full items-center justify-center">
       <div className='w-fit mx-auto text-white flex items-center gap-2'>
            <div className='w-fit bg-white/10 flex items-center p-2 rounded-md gap-2'>
                <img src="https://assets.learntube.ai/files/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449" loading="eager" alt="" width={24} height={24} className='w-6 h-6'/>
                <p className='font-medium text-xs'>LearnTube.ai</p>
            </div>
            <div className='h-[36px] w-[2px] bg-white/20' />
            <div className='flex flex-col items-center'>
                <p className='text-[10px] text-white/50'>backed by</p>
                <div className='flex gap-1 items-center'>
                <img src="https://assets.learntube.ai/files/post-payment-updates/use2460.svg?updatedAt=1728356838222" alt="" width={40} height={13} className='w-10 h-auto' />
                <img src="https://assets.learntube.ai/files/post-payment-updates/text3075.svg?updatedAt=1728356926579" alt="" width={64} height={13} className='w-16 h-auto' />
                </div>
            </div>
        </div>
      {variant === "owner" &&<div className="bg-[#4285F426] w-[36px] h-[36px] rounded-[6px] py-2 pl-2 pr-1 cursor-pointer flex justify-center items-center" onClick={(e)=> {Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_EDIT_BUTTON_CLICKED, { distinct_id: userDetails?.email }); dispatch({type: SET_EDIT_STATUS , payload : true})}}>
        <img src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/Group%20(1).png?updatedAt=1750349661347" alt=""></img>
    </div>}
    </div>
  );
};

export default NavbarOwner;
